import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';

import DropZone from 'components/Shared/DropZone';
import ClientSearch from 'components/Shared/ClientSearch';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';


import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import SvgIcon from '@mui/material/SvgIcon';


import ClientsIcon from '@mui/icons-material/TagFaces';
import PrioritairesIcon from '@mui/icons-material/PriorityHigh';
import NouveauxIcon from '@mui/icons-material/Report';
import AnciensIcon from '@mui/icons-material/ReportOff';

import { ImportClientsPrioritairesSteps } from './ImportClientsPrioritairesSteps.js';

import { green, red, blue, deepPurple } from '@mui/material/colors';

const styles = theme => ({

    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },

    link: theme.style.link,


    cardActions: {
        justifyContent: 'right'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },  
    
    cardsContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'stretch'
    },
    card: {
        flexGrow: '1',
        margin: "12px"
    },
    divider: {
        paddingTop: 16,
        paddingBottom: 16
    },

    content: {
        display: 'flex',
        alignItems: 'center'
    },
    title: {
        flex: '1 1 auto',
        marginLeft: 12
    },
    avatar: {
        flex: '0 0 auto',
        marginRight: 12,
        width: 60,
        height: 60,
        color: '#fff'
    },

    avatarClients: {
        backgroundColor: deepPurple[700]
    },
    avatarPrioritaires: {
        backgroundColor: blue[500]
    },

    avatarNouveaux: {
        backgroundColor: green[500]
    },

    avatarAnciens: {
        backgroundColor: red[700]
    },

    
    button: {
        margin: '8px 8px 0px 0px'
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    },


    
    clientSearch: {
        minHeight: 320
    }
});


const messages = [
    'Pas de changement',
    'Ajout',
    'Suppression',
    'Ignorer (Doublon)',

    // Inserer nouveau ici

    'Erreur'
];



class AdministrationClients extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fichiersIds: [],
            clientId: 0
        };
    }

    SpreadSheetIcon = () => {
        let { classes } = this.props;

        return (
            <SvgIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{ width: '20px', height: '20px' }} viewBox="0 0 20 20" >
                <path d="M19,11V9H11V5H9V9H5V11H9V19H11V11H19M19,3C19.5,3 20,3.2 20.39,3.61C20.8,4 21,4.5 21,5V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H19Z" />
            </SvgIcon>
        );
    };

    handleChangeClient = (client) => {
        this.setState(
            {
                ...this.state,
                clientId: client.id
            });
    };

    render() {
        let { clientId } = this.state;
        let { classes, onChange, onClickCancel, onClickSave, onClickExport, step, isPatching, clientsPrioritaires, error, importResult, sauvegardable } = this.props;

        return (
            <React.Fragment>

                <Typography gutterBottom variant="h5">
                    Administration des clients
                </Typography>

                <Card className={classes.paper}>
                    <Typography gutterBottom variant="h6">
                        Prioritaires
                    </Typography>

                    {(step === ImportClientsPrioritairesSteps.WaitFile) && (
                        <React.Fragment>
                            <Link to={`../RECLAMATIONS_import_clients_prioritaires_modele.xlsx`} target="_blank" className={classes.link}>
                                <Typography variant="button">
                                    Télécharger le fichier modèle
                                </Typography>
                            </Link>

                            <br />

                            <Button variant="outlined" size="small" className={classes.button} onClick={onClickExport} startIcon={<this.SpreadSheetIcon />}>
                                Exporter les clients prioritaires.
                            </Button>


                            <DropZone id="fichiersIds" name="fichiersIds" onChange={onChange} label="Fichier à importer" buttonLabel="Ajouter un fichier" />                                                        
                        </React.Fragment>
                    )}

                    {(step === ImportClientsPrioritairesSteps.LoadFile) && (
                        <React.Fragment>
                            <p>
                                Traitement du fichier en cours
                            </p>
                        </React.Fragment>
                    )}

                    {(step === ImportClientsPrioritairesSteps.SetClientsPrioritaires) && (
                        <React.Fragment>                            
                            {clientsPrioritaires && clientsPrioritaires.length > 0 && (
                                <React.Fragment>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Code client</TableCell>
                                                <TableCell>Raison sociale</TableCell>
                                                <TableCell>Action sur le flag prioritaire</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {clientsPrioritaires.map((client, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{client.codeClient}</TableCell>
                                                    <TableCell>{client.libelle}</TableCell>
                                                    <TableCell>{client.erreur ? messages[messages.length-1] : messages[client.changement]}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>

                                    </Table>

                                    <CardActions classes={{ root: classes.cardActions }}>
                                        <Button onClick={onClickCancel} color="primary" >Annuler</Button>
                                        <Button
                                            onClick={onClickSave}
                                            variant="contained"
                                            color="secondary"
                                            disabled={isPatching || !sauvegardable}
                                        >
                                            {isPatching && <CircularProgress size={24} className={classes.buttonProgress} />}
                                            Enregistrer
                                        </Button>
                                    </CardActions>
                                </React.Fragment>
                            )}

                            {(!clientsPrioritaires || clientsPrioritaires.length === 0) && !error && (                            
                                <React.Fragment>
                                    <p>
                                        Fichier vide
                                    </p>
                                    <CardActions classes={{ root: classes.cardActions }}>
                                        <Button onClick={onClickCancel} variant="contained" color="secondary">Continuer</Button>
                                    </CardActions>
                                </React.Fragment>
                            )}

                            {error && (
                                <React.Fragment>

                                    <CardContent>
                                        <p>
                                            "Une erreur est intervenue lors du traitement du fichier des clients prioritaires "
                                        </p>
                                        <p>
                                            {error.error.message} - {error.error.response.statusText}
                                        </p>
                                        <p>
                                            <span dangerouslySetInnerHTML={{ __html: error.error.response.data }} />
                                        </p>
                                    </CardContent>

                                    <CardActions classes={{ root: classes.cardActions }}>
                                        <Button onClick={onClickCancel} color="primary" >Annuler</Button>
                                    </CardActions>

                                </React.Fragment>
                            )}

                        </React.Fragment>
                    )}

                    {(step === ImportClientsPrioritairesSteps.WaitImport) && (
                        <p>
                            Enregistrement en cours
                        </p>
                    )}

                    {(step === ImportClientsPrioritairesSteps.ImportResult) && error && (
                        <React.Fragment>
                            <CardContent>
                                <p>
                                    "Une erreur est intervenue lors de l'enregistrement des clients prioritaires "
                                </p>
                                <p>
                                    {error.error.message} - {error.error.response.statusText}
                                </p>
                                <p>
                                <span dangerouslySetInnerHTML={{ __html: error.error.response.data }} />
                                </p>
                            </CardContent>

                            <CardActions classes={{ root: classes.cardActions }}>
                                <Button onClick={onClickCancel} color="primary" >Annuler</Button>
                            </CardActions>

                        </React.Fragment>
                    )}
          
                    {(step === ImportClientsPrioritairesSteps.ImportResult) && importResult && (
                        <React.Fragment>
                            <CardContent>
                                <div className={classes.cardsContainer}>

                                    <Card className={classes.card}>
                                        <CardContent>
                                            <div className={classes.content}>
                                                <Avatar className={classNames(classes.avatar, classes.avatarClients)}>
                                                    <ClientsIcon />
                                                </Avatar>
                                                <div className={classes.title}>
                                                    <Typography variant="subtitle1" gutterBottom>Clients</Typography>
                                                    <Typography variant="h6" gutterBottom>{importResult.nbClient}</Typography>
                                                </div>
                                            </div>
                                            <div className={classes.divider}>
                                                <Divider />
                                            </div>
                                            <Typography variant="caption">{`Nombre de clients`}</Typography>
                                        </CardContent>
                                    </Card>

                                    <Card className={classes.card}>
                                        <CardContent>
                                            <div className={classes.content}>
                                                <Avatar className={classNames(classes.avatar, classes.avatarPrioritaires)}>
                                                    <PrioritairesIcon />
                                                </Avatar>
                                                <div className={classes.title}>
                                                    <Typography variant="subtitle1" gutterBottom>Prioritaires</Typography>
                                                    <Typography variant="h6" gutterBottom>{importResult.nbPrioritaires}</Typography>
                                                </div>
                                            </div>

                                            <div className={classes.divider}>
                                                <Divider />
                                            </div>
                                            <Typography variant="caption">{`Nombre de clients prioritaires`}</Typography>
                                        </CardContent>
                                    </Card>

                                    <Card className={classes.card}>
                                        <CardContent>
                                            <div className={classes.content}>
                                                <Avatar className={classNames(classes.avatar, classes.avatarNouveaux)}>
                                                    <NouveauxIcon />
                                                </Avatar>
                                                <div className={classes.title}>
                                                    <Typography variant="subtitle1" gutterBottom>Nouveaux</Typography>
                                                    <Typography variant="h6" gutterBottom>{importResult.nbPrioritairesAjoutes}</Typography>
                                                </div>
                                            </div>

                                            <div className={classes.divider}>
                                                <Divider />
                                            </div>
                                            <Typography variant="caption">{`Nombre de nouveaux clients prioritaires`}</Typography>
                                        </CardContent>
                                    </Card>

                                    <Card className={classes.card}>
                                        <CardContent>
                                            <div className={classes.content}>
                                                <Avatar className={classNames(classes.avatar, classes.avatarAnciens)}>
                                                    <AnciensIcon />
                                                </Avatar>
                                                <div className={classes.title}>
                                                    <Typography variant="subtitle1" gutterBottom>Anciens</Typography>
                                                    <Typography variant="h6" gutterBottom>{importResult.nbPrioritairesSupprimes}</Typography>
                                                </div>
                                            </div>

                                            <div className={classes.divider}>
                                                <Divider />
                                            </div>
                                            <Typography variant="caption">{`Nombre de clients devenus non prioritaires`}</Typography>
                                        </CardContent>
                                    </Card>
                                </div>
                            </CardContent>

                            <CardActions classes={{ root: classes.cardActions }}>
                                <Button onClick={onClickCancel} variant="contained" color="secondary">Continuer</Button>
                            </CardActions>
                        </React.Fragment>
                    )}
                </Card>

                <Card className={classNames(classes.paper, classes.clientSearch)}>
                    <Typography gutterBottom variant="h6">
                        Choix d'un client à éditer
                    </Typography>

                    <ClientSearch
                        namespace={"administration"}
                        onChange={this.handleChangeClient}
                        isRequired={false}
                        activitesAutorisees={[]}
                        activitesExclues={[]}
                    />

                    {(clientId === 0) && 
                        <Button disabled>Éditer</Button>
                    }

                    {(clientId !== 0) &&
                        <Link to={`/administration/clients/${clientId}`} className={classes.link}>
                            <Button>Éditer</Button>
                        </Link>
                    }
                </Card>
            </React.Fragment>
        );
    }
}

AdministrationClients.propTypes = {
    classes: PropTypes.object.isRequired,
    //clients: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationClients);